import { Cryptocurrency } from "../../types/assets";
import api from "../api";

export const getCryptocurrencies = async (): Promise<{
  data: Cryptocurrency[];
}> => {
  const { data } = await api.get("/v2/crypto?limit=9999");
  return data;
};
